import classnames from 'classnames';
import { IconMusic } from '@picsart/design-system/foundation/icons/IconMusic';
import { WAVEFORM_BARS, WAVEFORM_BARS_LIGHTBOX } from '@/consts/audio';
import useStyles from './styles';
import { CardAudioVariant, type CardAudioProps } from './types';

const CardAudio = ({
  variant = CardAudioVariant.Card,
  isPlaying,
}: CardAudioProps) => {
  const classes = useStyles();
  const isLightbox = variant === CardAudioVariant.Lightbox;
  const bars = isLightbox ? WAVEFORM_BARS_LIGHTBOX : WAVEFORM_BARS;

  return (
    <div
      className={classnames(classes.audioPlaceholder, {
        [classes.audioPlaceholderLightbox]: isLightbox,
      })}
      role="img"
      aria-label="Audio"
    >
      <div
        className={classnames(classes.audioGlow, {
          [classes.audioGlowLightbox]: isLightbox,
        })}
      />
      <div
        className={classnames(classes.audioIconRing, {
          [classes.audioIconRingLightbox]: isLightbox,
        })}
      >
        <IconMusic
          fill="currentColor"
          className={classnames(classes.audioIcon, {
            [classes.audioIconLightbox]: isLightbox,
          })}
        />
      </div>
      <div
        className={classnames(classes.audioWaveform, {
          [classes.audioWaveformLightbox]: isLightbox,
        })}
      >
        {bars.map((bar) => (
          <span
            key={bar.id}
            className={classnames(classes.audioBar, {
              [classes.audioBarLightbox]: isLightbox,
            })}
            style={{
              height: bar.height,
              animationDelay: bar.animationDelay,
              // Explicit 'running'/'paused' avoids relying on "undefined removes property" behavior.
              // isPlaying === false (not !isPlaying) preserves 'running' when prop is not passed (grid cards).
              animationPlayState: isPlaying === false ? 'paused' : 'running',
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default CardAudio;
